export default __webpack_public_path__ + "static/media/gallery-wip-emitter-cover_00.f122314d.jpg";